export default {
  badge: 'Märk',
  open: 'Ava',
  close: 'Sulge',
  dismiss: 'Loobu',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Tühista',
  },
  dataIterator: {
    noResultsText: 'Vastavaid kirjeid ei leitud',
    loadingText: 'Andmeid laaditakse...',
  },
  dataTable: {
    itemsPerPageText: 'Ridu leheküljel:',
    ariaLabel: {
      sortDescending: 'Kahanevalt sorteeritud.',
      sortAscending: 'Kasvavalt sorteeritud.',
      sortNone: 'Ei ole sorteeritud.',
      activateNone: 'Vajuta uuesti sorteerimise eemaldamiseks.',
      activateDescending: 'Vajuta uuesti, et sorteerida kahanevalt.',
      activateAscending: 'Vajuta kasvavalt sorteerimiseks.',
      selectRow: 'Vali rida',
      selectAll: 'Vali kõik',
      selectGroup: 'Vali rühm',
    },
    sortBy: 'Sorteerimise alus',
  },
  dataFooter: {
    itemsPerPageText: 'Kirjeid leheküljel:',
    itemsPerPageAll: 'Kõik',
    nextPage: 'Järgmine lehekülg',
    prevPage: 'Eelmine lehekülg',
    firstPage: 'Esimene lehekülg',
    lastPage: 'Viimane lehekülg',
    pageText: '{0}-{1} {2}st',
  },
  dateRangeInput: {
    divider: 'kuni',
  },
  monthPicker: {
    title: 'Valige kuu',
    itemsSelected: '{0} valitud',
    header: 'Sisesta kuu',
    range: {
      title: 'Sisesta kuud',
    },
    ariaLabel: {
      previousYear: 'Eelmine aasta',
      nextYear: 'Järgmine aasta',
      selectYear: 'Vali aasta',
      currentMonth: 'Praegune kuu, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} valitud',
    range: {
      title: 'Vali kuupäevad',
      header: 'Sisesta kuupäevad',
    },
    title: 'Vali kuupäev',
    header: 'Sisesta kuupäev',
    input: {
      placeholder: 'Sisesta kuupäev',
    },
    ariaLabel: {
      previousMonth: 'Eelmine kuu',
      nextMonth: 'Järgmine kuu',
      selectYear: 'Vali aasta',
      previousYear: 'Eelmine aasta',
      nextYear: 'Järgmine aasta',
      selectMonth: 'Valige kuu',
      selectDate: '{0}',
      currentDate: 'Täna, {0}',
    },
  },
  noDataText: 'Andmed puuduvad',
  carousel: {
    prev: 'Eelmine visuaalne',
    next: 'Järgmine visuaalne',
    ariaLabel: {
      delimiter: 'Karusselli slaid {0} {1}st',
    },
  },
  calendar: {
    moreEvents: '{0} veel',
    today: 'Täna',
  },
  heatmap: {
    less: 'Vähem',
    more: 'Rohkem',
  },
  input: {
    clear: 'Tühjenda {0}',
    prependAction: '{0} eelnev toiming',
    appendAction: '{0} lisatud toiming',
    otp: 'Sisestage kinnituskood',
  },
  fileInput: {
    counter: '{0} faili',
    counterSize: '{0} faili (kokku {1})',
  },
  fileUpload: {
    title: 'Lohista ja lase failid siia',
    divider: 'või',
    browse: 'Sirvi faile',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Vali aeg',
    hour: 'Tund',
    minute: 'Minut',
    second: 'Sekund',
    notAllowed: 'Väärtus ei ole lubatud',
  },
  pagination: {
    ariaLabel: {
      root: 'Lehekülgede navigeerimine',
      next: 'Järgmine lehekülg',
      previous: 'Eelmine lehekülg',
      page: 'Mine lehele {0}',
      currentPage: 'Praegune leht, leht {0}',
      first: 'Esimene lehekülg',
      last: 'Viimane lehekülg',
    },
  },
  stepper: {
    next: 'Järgmine',
    prev: 'Eelmine',
  },
  rating: {
    ariaLabel: {
      item: 'Hinnang {0} {1}st',
    },
  },
  loading: 'Laadimine...',
  infiniteScroll: {
    loadMore: 'Laadi rohkem',
    empty: 'Pole rohkem',
  },
  rules: {
    required: 'See väli on kohustuslik',
    email: 'Palun sisesta kehtiv e-posti aadress',
    number: 'See väli võib sisaldada ainult numbreid',
    integer: 'See väli võib sisaldada ainult täisarve',
    capital: 'See väli võib sisaldada ainult suurtähti',
    maxLength: 'Sisestada tuleb maksimaalselt {0} märki',
    minLength: 'Sisestada tuleb vähemalt {0} märki',
    strictLength: 'Sisestatud välja pikkus ei ole kehtiv',
    exclude: 'Märk {0} ei ole lubatud',
    notEmpty: 'Palun vali vähemalt üks väärtus',
    pattern: 'Vale vorming',
  },
  command: {
    search: 'Sisestage käsk või otsige...',
  },
  hotkey: {
    then: 'siis',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Nool üles',
    downArrow: 'Nool alla',
    leftArrow: 'Nool vasakule',
    rightArrow: 'Nool paremale',
    backspace: 'Tagasiklahv',
    space: 'Tühik',
    plus: 'pluss',
    shortcut: 'Klaviatuuri otsetee: {0}',
    or: 'või',
  },
  video: {
    play: 'Esita',
    pause: 'Peata',
    seek: 'Otsi',
    volume: 'Helitugevus',
    showVolume: 'Näita helitugevuse regulaatorit',
    mute: 'Vaigista',
    unmute: 'Lülita vaigistus välja',
    enterFullscreen: 'Täisekraan',
    exitFullscreen: 'Välju täisekraanilt',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Võta värv ekraanilt',
      hueSlider: 'Toon',
      alphaSlider: 'Alfa',
      redInput: 'Punane',
      greenInput: 'Roheline',
      blueInput: 'Sinine',
      alphaInput: 'Alfa',
      hueInput: 'Toon',
      saturationInput: 'Küllastus',
      lightnessInput: 'Heledus',
      hexInput: 'HEKS väärtus',
      hexaInput: 'HEKS koos alfa väärtusega',
      changeFormat: 'Muuda värvi formaati',
    },
  },
}
